
export const appConfig = {
    appName: "Growhold",
    prismicRepository: 'growhold',
    namespace: 'https://app.growhold.com',
    auth0: false,
    auth0_domain: "auth.growhold.com",
    auth0_clientId: "Q8JIwavsPHIoG9VcGp7W3A6YIYOII7fU",
    auth0_scope: "read:current_user read:current_user_metadata",
    email_verification: true,
    signup_allowed: true,
    signin_google: false,
    stripe_enabled: true,
    display_mode: "system",
    initiativeThread: true,
    initiativeThreadSummaries: false,
    initiativeTypes: [ "launchpad" ],
    initiativeAssistants: {
        "launchpad": "disabled",
        "client": "disabled", 
        "content": "disabled",  
        "script": "disabled"
    }
};

export const firebaseConfig = {
    apiKey: "AIzaSyD1EVdONg16Y71q-3IDq8N39lN__0Ut5IE",
    authDomain: "growhold-app.firebaseapp.com",
    projectId: "growhold-app",
    storageBucket: "growhold-app.appspot.com",
    messagingSenderId: "586706458851",
    appId: "1:586706458851:web:3e55ff1de5b494bd100dd6",
    measurementId: "G-8DHTJ3YF3M"
};